import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const AICaseStudiesWrapper = styled.section`
  padding: 100px 0;
  background: #fff;

  @media (max-width: 767px) {
    padding: 60px 0;
  }

  .section-header {
    text-align: center;
    margin-bottom: 50px;
  }

  h2 {
    font-size: 42px;
    font-weight: 300;
    color: #1a1a2e;
    letter-spacing: -0.025em;
    line-height: 1.2;
    margin-bottom: 20px;

    @media (max-width: 991px) {
      font-size: 36px;
    }
    @media (max-width: 575px) {
      font-size: 28px;
    }
  }

  .section-subtitle {
    font-size: 18px;
    color: #666;
    max-width: 650px;
    margin: 0 auto;
    line-height: 1.7;
    font-weight: 300;

    @media (max-width: 575px) {
      font-size: 16px;
    }
  }

  .case-study-nav {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 40px;
  }

  .nav-tab {
    padding: 12px 24px;
    font-size: 15px;
    font-weight: 500;
    color: #666;
    background: #f8f9fa;
    border: 1px solid #e8e8e8;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      color: #333;
      border-color: rgba(241, 102, 0, 0.3);
      background: #fff;
    }

    &.active {
      color: #fff;
      background: linear-gradient(135deg, #f16600 0%, #ff8534 100%);
      border-color: transparent;
      box-shadow: 0 6px 20px rgba(241, 102, 0, 0.25);
    }

    @media (max-width: 575px) {
      font-size: 13px;
      padding: 10px 18px;
    }
  }

  .case-study-content {
    background: #f8f9fa;
    border-radius: 16px;
    border: 1px solid #e8e8e8;
    overflow: hidden;
    animation: ${fadeIn} 0.4s ease-out;
  }

  .cs-header {
    padding: 35px 40px 25px;
    border-bottom: 1px solid #e8e8e8;

    .cs-subtitle {
      font-size: 12px;
      font-weight: 700;
      color: #f16600;
      text-transform: uppercase;
      letter-spacing: 0.12em;
      display: block;
      margin-bottom: 8px;
    }

    h3 {
      font-size: 28px;
      font-weight: 600;
      color: #1a1a2e;
      margin: 0;

      @media (max-width: 575px) {
        font-size: 22px;
      }
    }

    @media (max-width: 575px) {
      padding: 25px;
    }
  }

  .cs-body {
    padding: 35px 40px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;

    @media (max-width: 767px) {
      grid-template-columns: 1fr;
      padding: 25px;
      gap: 25px;
    }
  }

  .cs-section {
    h4 {
      font-size: 12px;
      font-weight: 700;
      color: #f16600;
      text-transform: uppercase;
      letter-spacing: 0.12em;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      gap: 8px;

      &::before {
        content: '';
        width: 16px;
        height: 2px;
        background: #f16600;
        border-radius: 2px;
      }
    }

    p {
      font-size: 15px;
      color: #555;
      line-height: 1.7;
      margin: 0;
    }

    &.results {
      grid-column: 1 / -1;

      ul {
        list-style: none;
        padding: 0;
        margin: 0;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;

        @media (max-width: 575px) {
          grid-template-columns: 1fr;
        }
      }

      li {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        font-size: 15px;
        color: #333;
        line-height: 1.5;
        padding: 12px 16px;
        background: #fff;
        border-radius: 10px;
        border: 1px solid #e8e8e8;

        svg {
          flex-shrink: 0;
          margin-top: 2px;
        }
      }
    }
  }

  .cs-technologies {
    padding: 20px 40px 30px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;

    @media (max-width: 575px) {
      padding: 15px 25px 25px;
    }
  }

  .tech-tag {
    font-size: 12px;
    font-weight: 500;
    color: #666;
    padding: 5px 14px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 20px;
  }
`;

export default AICaseStudiesWrapper;
